"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.assetsUrl = void 0;
var assetsUrl = 'https://d1k0rbiro50qe0.cloudfront.net';
exports.assetsUrl = assetsUrl;